import React from "react";
import { Grid } from "@material-ui/core";
import { Values } from "@src/Tools/Values";

export default class ResultsAreEmpty extends React.Component {
  render() {
    return (
      <Grid
        container
        justify="center"
        alignContent="center"
        style={{ marginTop: 25 }}
      >
        {Values.getLocalizationValue("thereAreNoItems")}
      </Grid>
    );
  }
}
